// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import './styles/theme.css';
// FAZ-97 madde 9 — popover oku (tüm açılır yüzeyler için tek kaynak)
import './styles/popover.css';
// ARSUZ'A ÖZGÜ: görev / sohbet / bildirim modülleri Kırıkhan'ın lacivert+altın
// paletini kullanır. theme.css'e DOKUNMAZ; yalnız o modüllerin DOM alt ağacında
// marka değişkenlerini yeniden tanımlar. Gerekçe dosyanın başlığında.
import './styles/gorev-mesajlasma-palet.css';

import App from './App'; // Ortak "App" bileşeni

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>
);
